import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { Form, RadioButton, color, fontWeight, fontSize } from 'stylist'

const Radio = styled(RadioButton)`
  & + label {
    div {
      ${fontSize('m')};
    }
    span {
      ${fontSize('xs')};
      color: ${color('slate')};
      ${fontWeight('regular')};
    }
  }
`

const FormGroup = styled(Form.Group)`
  position: relative;

  div[role='alert'] {
    max-width: 50%;
  }
`

const PiiInput = () => (
  <FormGroup>
    <Form.Field
      name="pii"
      render={({ value, setValue, renderError }) => (
        <Fragment>
          <Radio
            id="pii-yes"
            label="Yes"
            checked={!!value}
            onChange={() => setValue(true)}
          />
          <Radio
            id="pii-no"
            label="No"
            checked={value === false}
            onChange={() => setValue(false)}
          />
          {renderError()}
        </Fragment>
      )}
    />
  </FormGroup>
)

export default PiiInput



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/PiiInput.js